import Cookies from 'js-cookie';

export default class AttentionBanderole {
	closeButton;

	constructor(props) {
		this.banderole = document.querySelector(props.banderole);
		this.hideCookie = props.hideCookie;
		this.setUp(props);
	}

	setUp = props => {
		if (Cookies.get(this.hideCookie.name) || !this.banderole) {
			this.kill();
			return;
		}

		this.closeButton = this.banderole.querySelector(props.closeButton);
		this.banderole.classList.remove('hidden');
		this.closeButton.addEventListener('click', this.closeAttentionBanderole);
	};

	closeAttentionBanderole = () => {
		Cookies.set(this.hideCookie.name, 'true', { expires: this.hideCookie.expiresAfterDays });
		this.kill();
	};

	kill = () => {
		this.banderole?.remove();
	};
}
